import ballshaders from "./ballshaders.js"
import RAF from "../utils/RAF"
import ballArtKeyframes from "./ball-art-keyframes.js"
import gsap from 'gsap'

class BallArt {
  constructor() {
    this.bind()
  }
  init(scene) {
    this.texLoader = new THREE.TextureLoader()
    this.scene = scene
    this.pointInt = new THREE.Vector3()
    this.mIntTarget = 0
    this.ballSubDiv = 25

    this.uniforms = {
      u_matCap: { value: this.texLoader.load(webglAssets.ball) },
      u_time: { value: 0. },
      pi: { value: Math.PI },
      u_progess: { value: 0 },
      u_op: { value: 1 },

      u_f1speed: { value: ballArtKeyframes.frame1.speed },
      u_f1freq: { value: ballArtKeyframes.frame1.freq },
      u_f1amp: { value: ballArtKeyframes.frame1.amp },

      u_f2speed: { value: ballArtKeyframes.frame2.speed, },
      u_f2freqy: { value: ballArtKeyframes.frame2.freqy },
      u_f2freqrad: { value: ballArtKeyframes.frame2.freqrad },
      u_f2ampy: { value: ballArtKeyframes.frame2.ampy },
      u_f2amprad: { value: ballArtKeyframes.frame2.amprad },

      u_f3speed: { value: ballArtKeyframes.frame3.speed },
      u_f3freqy: { value: ballArtKeyframes.frame3.freqy },
      u_f3freqrad: { value: ballArtKeyframes.frame3.freqrad },
      u_f3ampy: { value: ballArtKeyframes.frame3.ampy },
      u_f3amprad: { value: ballArtKeyframes.frame3.amprad },

      u_f4speed: { value: ballArtKeyframes.frame4.speed },
      u_f4freq: { value: ballArtKeyframes.frame4.freq },
      u_f4amp: { value: ballArtKeyframes.frame4.amp },


      u_dispFunc: { value: 2 },
      u_bumpPos: { value: new THREE.Vector3() },
      u_bumpInt: { value: 0 },
      u_bumRadius: { value: 3 },
      u_bumAmp: { value: 0.4 },
    }

    this.generateBall(this.ballSubDiv)
  }

  generateBall(subd) {
    if (!this.scene) return
    this.scene.traverse(child => {
      if (child.name == "ballArt") {
        this.scene.remove(child)
      }
    })
    this.shaderMat = new THREE.ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: ballshaders.vertexShader,
      fragmentShader: ballshaders.fragmentShader,
    })

    const geom = new THREE.IcosahedronGeometry(3, subd)
    this.ballMesh = new THREE.Mesh(geom, this.shaderMat)
    this.ballMesh.name = "ballArt"


    this.animTimeline = gsap.timeline({
      paused: true
    })

    this.animTimeline.to(this.ballMesh.position, {
      z: -5,
      duration: .8,
    }, 0)
    this.animTimeline.to(this.ballMesh.material.uniforms.u_op, {
      value: 0,
      duration: .8,
    }, 0)

    this.scene.add(this.ballMesh)
  }

  update(intersects, progress) {
    this.ballMesh.material.uniforms.u_time.value += RAF.dt
    this.mIntTarget = 0
    intersects.forEach(child => {
      if (child.object.name == this.ballMesh.name) {
        this.pointInt = child.point
        this.mIntTarget = 1
      }
    })

    this.ballMesh.material.uniforms.u_bumpPos.value.x += (this.pointInt.x - this.ballMesh.material.uniforms.u_bumpPos.value.x) * 0.05
    this.ballMesh.material.uniforms.u_bumpPos.value.y += (this.pointInt.y - this.ballMesh.material.uniforms.u_bumpPos.value.y) * 0.05
    this.ballMesh.material.uniforms.u_bumpPos.value.z += (this.pointInt.z - this.ballMesh.material.uniforms.u_bumpPos.value.z) * 0.05

    this.ballMesh.material.uniforms.u_bumpInt.value += (this.mIntTarget - this.ballMesh.material.uniforms.u_bumpInt.value) * 0.05
    this.ballMesh.material.uniforms.u_progess.value = progress

    if (this.animTimeline)
      this.animTimeline.time(Math.min(Math.max(progress - 4, 0), this.animTimeline.duration()))
  }

  bind() {
    this.init = this.init.bind(this)
    this.generateBall = this.generateBall.bind(this)
  }
}

const _instance = new BallArt()
export default _instance
